(function () {
  const HOST_SELECTOR = '.widerruf-form-block[data-widerruf-shadow-ready="1"]';
  const STYLE_ATTR = 'data-widerruf-theme-style';

  const SHADOW_CSS = `
    :host,
    [data-widerruf-shadow-root] {
      font-family: var(--font-body-family) !important;
      color: rgb(var(--color-foreground)) !important;
    }

    .widerruf-form-card__title,
    .widerruf-form-step-intro__title,
    .widerruf-form__success-title {
      font-family: var(--font-heading-family) !important;
      font-weight: var(--font-heading-weight) !important;
      color: rgb(var(--color-foreground-title)) !important;
    }

    .widerruf-form__label,
    .widerruf-form__hint,
    .widerruf-form-step-intro__text,
    .widerruf-form__privacy-notice,
    .widerruf-form-step-pill,
    .widerruf-form-branding__text {
      font-family: var(--font-body-family) !important;
    }

    .widerruf-form__input {
      border-color: rgb(var(--color-border-input)) !important;
      color: rgb(var(--color-input-text)) !important;
      background: rgb(var(--color-background-input)) !important;
      border-radius: 0.8rem !important;
      min-height: 5rem !important;
      padding: 1rem 1.6rem !important;
      font-family: var(--font-body-family) !important;
      font-size: 1.4rem !important;
      transition: border var(--duration-default, 0.3s ease), background-color var(--duration-default, 0.3s ease);
    }

    .widerruf-form__input:focus,
    .widerruf-form__input:focus-visible {
      outline: none !important;
      border-color: rgb(var(--color-border-input-hover)) !important;
      background: rgb(var(--color-background-input-hover)) !important;
    }

    .widerruf-form__input::placeholder {
      color: rgb(var(--color-input-placeholder)) !important;
    }

    .widerruf-primary-button {
      font-family: var(--font-button-family, var(--font-body-family)) !important;
      font-weight: var(--font-button-weight, 400) !important;
      text-transform: var(--font-button-text-transform, none) !important;
      letter-spacing: var(--font-button-letter-spacing, normal) !important;
      border: none !important;
    }

    .widerruf-button--link {
      color: rgb(var(--color-button)) !important;
      font-family: var(--font-body-family) !important;
    }

    .widerruf-form-card__header,
    .widerruf-form-divider {
      border-color: rgb(var(--color-border)) !important;
    }

    .widerruf-form-step-pill {
      background: rgb(var(--colors-accent-1)) !important;
      border-color: rgb(var(--color-border)) !important;
      color: rgb(var(--color-foreground-secondary)) !important;
    }

    .widerruf-form-step-pill[aria-current="step"] {
      background: rgb(var(--colors-accent-2)) !important;
      color: rgb(var(--color-foreground-title)) !important;
      border-color: rgb(var(--colors-accent-3)) !important;
    }

    .widerruf-form-divider {
      background: rgb(var(--color-border)) !important;
    }

    .widerruf-form a {
      color: rgb(var(--color-button)) !important;
    }

    .widerruf-form__error {
      color: rgb(var(--colors-error)) !important;
    }

    .widerruf-required {
      color: rgb(var(--colors-error)) !important;
    }

    .widerruf-form-branding {
      display: none !important;
    }
  `;

  function styleHost(host) {
    const root = host.shadowRoot;
    if (!root || root.querySelector(`[${STYLE_ATTR}]`)) return;

    const style = document.createElement('style');
    style.setAttribute(STYLE_ATTR, 'true');
    style.textContent = SHADOW_CSS;
    root.appendChild(style);
  }

  function styleAll() {
    document.querySelectorAll(HOST_SELECTOR).forEach(styleHost);
  }

  styleAll();

  const observer = new MutationObserver(styleAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', styleAll);
  window.addEventListener('load', styleAll);
})();
